// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_dropdown_top-module__container--2Chvq"};